import { openWindow } from '@umu/umu-dom';
import React, { useEffect, useState } from 'react';
import './searchInputForContentOfUmuMicroPage.scss';
import { cleanHistory, searchHistory } from '@umu/umu-api';
import { IAppSearchData, IAppRecommendData } from '@umu/umu-types';
import { SearchRange } from '@umu/umu-search/src/searchInputForContent/common/interface';
import { INPUT_CLICK_STATUS } from '@umu/umu-search/src/searchInputForContent/common/interface';
import {
    defaultRecommendData,
    getFilterParams,
    getParametersByObj,
} from '@umu/umu-search/src/searchInputForContent/common/dataflow';
import {
    getRecommandData,
    getMicroPageSearchData,
    paramsData,
} from '@umu/umu-search/src/searchInputForContent/common/service';
import SearchInputForContentBase from '@umu/umu-search/src/searchInputForContent/common/components/searchInputForContentBase/searchInputForContentBase';

type SearchInputForContentOfUmuMicroPageProps = {
    eid?: string;
    sort?: string;
    isLogin?: boolean;
    keyWords?: string;
    categoryId?: string;
    goBack?: () => void;
    microPageId?: string;
    searchRange: SearchRange;
    isEnterpriseAccount?: boolean;
    handleSearchOfMicroPage: (keyWords: string) => void;
    changeSearchRange?: (searchRange: SearchRange) => void;
};

function SearchInputForContentOfUmuMicroPage(props: SearchInputForContentOfUmuMicroPageProps) {
    const {
        eid,
        sort,
        goBack,
        keyWords,
        isLogin,
        microPageId,
        searchRange,
        categoryId,
        isEnterpriseAccount,
        handleSearchOfMicroPage,
        changeSearchRange: changeSearchRangeProp,
    } = props;
    const [recommandData, setRecommandData] = useState<IAppRecommendData>(defaultRecommendData);

    const buildSearchUrl = (param: { [x: string]: string | number }) => {
        const hrefConnect = getParametersByObj(
            getFilterParams({
                ...param,
            }),
        );
        const urls = hrefConnect !== '' ? `?${hrefConnect}` : '';
        return `/search/result/${urls}`;
    };

    const searchCallback = (keyWords: string, _searchRange?: string) => {
        _searchRange = _searchRange || searchRange;

        switch (_searchRange) {
            case SearchRange.currentPage:
                handleSearchOfMicroPage?.(keyWords);
                break;
            case SearchRange.wholeStation:
                const url = buildSearchUrl({
                    keyWords,
                    eid: eid || '',
                    sort: sort || '',
                    categoryId: categoryId || '',
                });
                openWindow(url, '_blank');
                goBack?.();
                break;
        }
    };

    const changeSearchRange = (_searchRange: SearchRange, keyword: string) => {
        if (keyword === '') {
            changeSearchRangeProp?.(_searchRange);

            return;
        }

        searchCallback(keyword, _searchRange);
    };

    const cleanCallback = async () => {
        await cleanHistory();
        const historyData = await searchHistory(paramsData);
        setRecommandData(Object.assign(recommandData || defaultRecommendData, { historySearch: historyData.list }));
    };

    const clickCallback = (data: IAppSearchData, key: INPUT_CLICK_STATUS) => {
        const urls = (data.extends && data.extends.share_url) || data.group_url || data.share_url || '';
        switch (key) {
            case INPUT_CLICK_STATUS.BUBBLE:
                searchCallback(data.keyword || '');
                break;
            case INPUT_CLICK_STATUS.POPULAR:
            case INPUT_CLICK_STATUS.COURSE:
            case INPUT_CLICK_STATUS.LENOVO:
                openWindow(urls, '_blank');
                break;
            case INPUT_CLICK_STATUS.MOUSEDOWN:
                break;
            default:
                break;
        }
    };

    const searchInputCallback = async (key: string) => {
        if (key === '') {
            const newRecommendData = await getRecommandData();
            setRecommandData(newRecommendData);
        } else {
            const LenovoCourse = await getMicroPageSearchData({
                searchRange,
                keyword: key,
                micro_page_id: microPageId,
            });
            setRecommandData({ ...(recommandData || defaultRecommendData), LenovoCourse });
        }
    };

    const searchInputClearCallback = () => {
        goBack?.();
    };

    const searchInputOnChange = (key: string) => {
        if (key === '') {
            goBack?.();
        }
    };

    const initRecommandData = async () => {
        const newRecommendData = await getRecommandData();
        setRecommandData(newRecommendData);
    };

    useEffect(() => {
        initRecommandData();
    }, []);

    return (
        <div className="search-input-for-content search-input-for-content__umu-micro-page">
            <SearchInputForContentBase
                isLogin={isLogin}
                inputType="umuMicroPage"
                searchRange={searchRange}
                searchKeyword={keyWords}
                showFloatingLayer={true}
                defaultFloatValue={false}
                isHiddenSearchIcon={false}
                recommendData={recommandData}
                cleanCallback={cleanCallback}
                clickCallback={clickCallback}
                onChange={searchInputOnChange}
                searchCallback={searchCallback}
                changeSearchRange={changeSearchRange}
                searchInputCallback={searchInputCallback}
                isEnterpriseAccount={isEnterpriseAccount}
                searchInputClearCallback={searchInputClearCallback}
            />
        </div>
    );
}

export default SearchInputForContentOfUmuMicroPage;
